import axios from 'axios';
import StorageService from '../services/StorageService';

class BankAccountHttpService {
    static async getBankCodes() {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/bank_codes`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getBankAccount() {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/bank_account`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async createOrUpdateBankAccount(data) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/bank_account`,
                data,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
}

export default BankAccountHttpService;
